import React, { useEffect, useState } from "react";
import Layout from "@/components/Layout";
import api from "@/lib/api";
import { Award, Download } from "lucide-react";

export default function Certificates() {
  const [items, setItems] = useState([]);
  const [selected, setSelected] = useState(null);

  useEffect(() => { api.get("/certificates/mine").then(r => setItems(r.data)).catch(() => {}); }, []);

  const print = () => {
    window.print();
  };

  return (
    <Layout>
      <div className="px-10 py-10">
        <div className="overline mb-3">Achievements</div>
        <h1 className="editorial-h1 text-5xl mb-10">Certificates</h1>

        {items.length === 0 ? (
          <div className="editorial-card-static p-16 text-center">
            <Award size={48} strokeWidth={1} className="mx-auto mb-4 text-[#52525B]" />
            <div className="font-serif text-3xl mb-2">No certificates yet.</div>
            <div className="text-[#52525B]">Complete a course to earn your first certificate.</div>
          </div>
        ) : (
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            {items.map(c => (
              <button key={c.cert_id} onClick={() => setSelected(c)} data-testid={`certificate-${c.cert_id}`} className="editorial-card p-6 text-left">
                <Award size={28} strokeWidth={1.5} className="text-[#E63946] mb-4" />
                <div className="overline mb-2">{c.cert_number}</div>
                <div className="font-serif text-2xl leading-tight mb-3">{c.course_title}</div>
                <div className="text-sm text-[#52525B]">Issued {new Date(c.issued_at).toLocaleDateString()}</div>
              </button>
            ))}
          </div>
        )}

        {selected && (
          <div className="fixed inset-0 bg-black/60 z-50 flex items-center justify-center px-4 print:bg-white print:relative print:inset-auto">
            <div className="bg-white max-w-3xl w-full border border-[#0A0A0A] p-12 relative print:border-none">
              <button onClick={() => setSelected(null)} className="absolute top-4 right-4 p-2 print:hidden">×</button>
              <div className="text-center">
                <div className="overline mb-4">Certificate of Completion</div>
                <Award size={60} strokeWidth={1} className="mx-auto text-[#E63946] mb-6" />
                <div className="text-sm text-[#52525B] mb-2">This certifies that</div>
                <div className="font-serif text-5xl font-light mb-4">{selected.user_name}</div>
                <div className="text-sm text-[#52525B] mb-2">has successfully completed</div>
                <div className="font-serif text-3xl mb-8">{selected.course_title}</div>
                <div className="h-px bg-[#0A0A0A] my-8 max-w-xs mx-auto" />
                <div className="grid grid-cols-2 gap-8 text-sm text-[#52525B]">
                  <div>
                    <div className="overline mb-1">Certificate #</div>
                    <div className="font-mono-jb">{selected.cert_number}</div>
                  </div>
                  <div>
                    <div className="overline mb-1">Issued</div>
                    <div className="font-mono-jb">{new Date(selected.issued_at).toLocaleDateString()}</div>
                  </div>
                </div>
                <div className="mt-10 font-serif text-2xl">Forge<span className="text-[#E63946]">.</span></div>
              </div>
              <button onClick={print} data-testid="download-cert" className="btn-primary w-full justify-center mt-8 print:hidden"><Download size={14}/> Download / Print</button>
            </div>
          </div>
        )}
      </div>
    </Layout>
  );
}
